export const PathsToHelpCodesMap = {
	"/dashboard/todo/setupdata": "home.setup",
	"/dashboard/todo/regularreports": "home.reports",
	"/dashboard/todo/links": "home.links",
	"/dashboard/todo/videohelp/viewed": "home.video",
	"/dashboard/todo/videohelp/new": "home.video",
	"/dashboard/summary": "summary",
	"/dashboard/costs": "costs.diary",
};
